import URL, { EMAIL_REVAMP } from '../helper';
import axiosCall from './interceptor';

export const createSMTPConfig = async data => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}addSMTPServerConfig`;
  if (!EMAIL_REVAMP) {
    url = `${URL.BASE_URL}addSMTPServerConfig`;
  }
  let response = await axiosCall('post', url, data, false);
  return response.data;
};

export const getAllSMTPConfig = async payload => {
  // TODO : include pagination
  let url = `${URL.TRANSACTION_SYSTEM_URL}getAllSMTPServerConfig`;
  if (!EMAIL_REVAMP) {
    url = `${URL.BASE_URL}getAllSMTPServerConfig`;
  }
  let response = await axiosCall('get', url);
  return response.data;
};

export const validateSMTPConfig = async payload => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}validateSMTPServerConfig`;
  if (!EMAIL_REVAMP) {
    url = `${URL.BASE_URL}validateSMTPServerConfig`;
  }
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const getAllFromAddress = async payload => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}fromAddress?${`status=${payload}`}`;
  if (!EMAIL_REVAMP) {
    url = `${URL.BASE_URL}fromAddress?${`status=${payload}`}`;
  }
  let response = await axiosCall('get', url);
  return response.data;
};

export const updateSMTPConfig = async payload => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}updateSMTPServerConfig`;
  if (!EMAIL_REVAMP) {
    url = `${URL.BASE_URL}updateSMTPServerConfig`;
  }
  const response = await axiosCall('put', url, payload, false);
  return response.data;
};

export const deleteSMTPConfig = async payload => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}deleteSMTPServerConfig?id=${payload.id}`;
  if (!EMAIL_REVAMP) {
    url = `${URL.BASE_URL}deleteSMTPServerConfig?id=${payload.id}`;
  }
  const response = await axiosCall('delete', url);
  return response.data;
};

export const changeDefaultSMTP = async id => {
  const url = `${URL.BASE_URL}defaultSMTP?smtpId=${id}`;
  const response = await axiosCall('put', url);
  return response.data;
};

export const fetchDomainList = async domain => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}sendingDomain`;
  if (!EMAIL_REVAMP) {
    url = `${URL.BASE_URL}sendingDomain`;
  }
  const response = await axiosCall('get', url);
  return response.data;
};

export const createNewDomain = async domain => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}sendingDomain?domain=${domain}`;
  if (!EMAIL_REVAMP) {
    url = `${URL.BASE_URL}sendingDomain?domain=${domain}`;
  }
  const response = await axiosCall('post', url);
  return response.data;
};

export const VerifyDomain = async id => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}verifySendingDomain?id=${id}`;
  if (!EMAIL_REVAMP) {
    url = `${URL.BASE_URL}verifySendingDomain?id=${id}`;
  }
  const response = await axiosCall('post', url);
  return response.data;
};

export const DeleteDomain = async id => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}sendingDomain?id=${id}`;
  if (!EMAIL_REVAMP) {
    url = `${URL.BASE_URL}sendingDomain?id=${id}`;
  }
  const response = await axiosCall('delete', url);
  return response.data;
};

export const fetchFromAddress = async id => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}fromAddress?domainId=${id}`;
  if (!EMAIL_REVAMP) {
    url = `${URL.BASE_URL}fromAddress?domainId=${id}`;
  }
  const response = await axiosCall('get', url);
  return response.data;
};

export const createFromAddress = async payload => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}fromAddress`;
  if (!EMAIL_REVAMP) {
    url = `${URL.BASE_URL}fromAddress`;
  }
  const response = await axiosCall('post', url, payload);
  return response.data;
};

export const deleteFromAddress = async id => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}fromAddress?id=${id}`;
  if (!EMAIL_REVAMP) {
    url = `${URL.BASE_URL}fromAddress?id=${id}`;
  }
  const response = await axiosCall('delete', url);
  return response.data;
};
